<script>
import baseEdit from "@/views/components/base/baseEdit.vue";
import dayjs from "dayjs";
export default {
  extends: baseEdit,
  components: {},
  data() {
    return {
      mname: "sysTask",
      key: "id",
      kv: "",
      selectC: "",
      url: {},
      items: [
        { label: "销售佣金", type: "header" },
        {
          label: "医院名称",
          name: "customerId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [{ required: true }],
          onChange: this.onChangecustomer,
          selected: 0,
        },
        {
          label: "项目名称",
          name: "projectId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          selected: 0,
        },
        {
          label: "客户经理",
          name: "userId",
          value: "",
          type: "selectDesk",
          width: "400px",
          dropList: [],
          rules: [{ required: true }],
          selected: 0,
        },
        {
          label: "月份",
          KeyEnter: this.search,
          name: "monthTime",
          value: dayjs().format("YYYY-MM"),
          width: "400px",
          type: "month",
          rules: [{ required: true }],
          onChange: this.getmonth,
        },
        {
          label: "佣金点(%)",
          name: "payProportion",
          value: "",
          width: "400px",
          type: "number",
          min: 0,
          max: 100,
          rules: [{ required: true }],
          onChange: this.getProportion,
        },
        {
          label: "佣金",
          name: "payMoney",
          value: 0,
          width: "400px",
          type: "label",
          disabled: true,
        },
      ],
      forms: {
        type: 2,
      },
      monthTime: "",
      customerId: Number(""),
      payProportion: Number(""),
    };
  },
  created() {
    let query = this.$route.query;
    this.loadAdminUserData();
    this.onChangeuserId(0);
    if (query.action === "edit") {
      this.items[this.getItemIndex("payMoney")].type = "number";
      this.kv = query.kv;
      this.initData();
    }
  },
  mounted() {},
  methods: {
    initData() {
      let id = this.kv;
      $utils.api.load(`/admin/system/payroll/${id}`, {}).then((res) => {
        if (res && res.data) {
          this.forms = res.data;
          this.onChangecustomer(res.data.customerId);
        }
      });
    },
    async handleSubmit() {
      if (!this.action) {
        return true;
      }
      let q = this.forms;
      await this.$refs.form.validate((valid) => {
        if (valid) {
          this.sloading = true;
          $utils.api
            .load(`/admin/system/payroll`, q, this.action == "edit" ? "PUT" : "POST")
            .then((res) => {
              this.sloading = false;
              if (res.status) {
                $utils.toast.success("保存成功");
                $utils.url.go(-1);
              }
            })
            .catch((e) => {
              this.sloading = false;
              $utils.toast.error("保存异常" + e.message);
            });
        }
      });
    },
    async loadAdminUserData() {
      let q = {};
      let res = await $utils.api.load("/admin/system/customer/list", q);
      if (res && res.rows) {
        let ll = res.rows;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.id;
          xx.name = element.customerName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "customerId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    async onChangecustomer(id) {
      this.customerId = id;
      let customerId = Number(id);
      let oldprojectId;
      if (this.forms.projectId) {
        oldprojectId = this.forms.projectId;
      }
      let res = await $utils.api.load(
        `/admin/system/management/parentCustomerList/${customerId}`
      );
      if (res && res.data) {
        let ll = res.data;
        if (ll && oldprojectId && this.action == "add") {
          this.forms.projectId = null;
          this.items[this.getItemIndex("projectId")].value = "";
        }
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          if (oldprojectId != element.id && this.action == "add") {
            this.forms.projectId = null;
            this.items[this.getItemIndex("projectId")].value = "";
          }
          let xx = {};
          xx.value = element.id;
          xx.name = element.name;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "projectId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    async onChangeuserId(id) {
      let q = {
        customerId: id,
      };
      let res = await $utils.api.load("/admin/system/maiUser/insCustomerList", q);
      if (res && res.data) {
        let ll = res.data;
        let dropList = [];
        for (let index = 0; index < ll.length; index++) {
          const element = ll[index];
          let xx = {};
          xx.value = element.userId;
          xx.name = element.nickName;
          dropList.push(xx);
        }
        for (let index = 0; index < this.items.length; index++) {
          const element = this.items[index];
          if (element && element.name == "userId") {
            this.items[index]["dropList"] = dropList;
          }
        }
      }
    },
    getmonth(data) {
      this.monthTime = data;
    },
    getProportion(data) {
      let id = this.customerId;
      let Time = this.monthTime;
      if (!id) {
        $utils.toast.error("请选择医院");
        return;
      }
      if (!Time) {
        $utils.toast.error("请选择月份");
        return;
      }
      this.payProportion = data;
      this.getpayMoney();
    },
    async getpayMoney() {
      let obj = {};
      if (this.customerId) {
        obj.customerId = this.customerId;
      } else {
        $utils.toast.error("请选择医院");
        return;
      }
      if (this.monthTime != "") {
        obj.monthTime = this.monthTime;
      } else {
        $utils.toast.error("请选择月份");
        return;
      }
      let res = await $utils.api.load("/admin/system/revenue/list", obj);
      if (res && res.rows) {
        let data = res.rows;
        let Revenuenum = data[0].monthRevenue ? data[0].monthRevenue : 0;
        let num = this.payProportion;
        let payMoney;
        if (!Revenuenum || Revenuenum == 0 || num == 0) {
          payMoney = 0.0;
        } else {
          payMoney = (Revenuenum * num) / 100;
        }
        this.forms.payMoney = payMoney.toFixed(2);
        this.items[6].value = payMoney.toFixed(2);
      }
    },
  },
};
</script>
